<template>
  <div class="l-container">
    <div class="l-container-main">
      <router-view />
    </div>
    <!-- <LFooter v-if="this.$route.name != 'home'" /> -->
  </div>
</template>

<script>
// import LFooter from "./footer";

export default {
  // components: {LFooter },
};
</script>

<style lang="stylus">
@import './layout.styl';
</style>
